import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import { withNamespaces } from 'react-i18next';
import Tabs from './tabs.js'

export class Main extends React.Component{   

    componentDidMount = async () =>{    
        const { t } = this.props
        document.title= t('Settings')
    }

    render(){
        return(     
            <main className="scrollbar-hidden">
                <Tabs />
            </main>
        )
    }  
}

const mapStateToProps = state => {
    return {
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data}),
        toggleSettings: (type) => dispatch({ type: type})  
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(Main));
